import { Pipe, PipeTransform } from '@angular/core';
import { Category } from '@interfaces/Category';

@Pipe({
  name: 'categoryBillableFinal'
})
export class CategoryBillableFinalPipe implements PipeTransform {
  public transform(category: Category): number {
    let total = 0;
    const classificationTotals = {};

    for (const estimateLine of category.estimateLines) {
      if (estimateLine.laborBillableFinal !== null) {
        total += estimateLine.laborBillableFinal;
      } else {
        for (const classificationLine of estimateLine.classificationLines) {
          classificationTotals[classificationLine.classificationEstimateId] = classificationLine.hours;
          const hoursCost: number = classificationLine.hours * classificationLine.rateCost;
          const hoursBillable = hoursCost * (1 + estimateLine.departmentEstimate.estimate.rate);
          total += hoursBillable;
        }
      }
    }

    return total;
  }
}
